module.exports = __webpack_public_path__ + "img/t3-c2.06aae1f4.png";